import React, { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { StaticQuery, graphql, Link } from 'gatsby';
import MenuItemDropdown from './MenuItemDropdown';
import ContactFormModal from './ContactFormModal';
import Logo from './logo-svg';
import Button from './atoms/Button';
import { ChevronLeft, ChevronDown, X, Facebook } from 'react-feather';
import {
	ArrowRight,
	BadgeCheck,
	FacebookIcon,
	ListOrdered,
	Target,
	TimerReset,
	TrendingUp,
	Users2
} from 'lucide-react';

import { Instagram } from 'react-feather';
import { Yelp } from '../components/atoms/yelp';
import { Google } from '../components/atoms/google';
import facebook from '../assets/icons/facebook';
import mascotSvg from './mascot_.svg';

const IconLink = ({ href, icon: Icon, ...props }) => (
	<a href={href} target="_blank" rel="nofollow noreferrer" className="p-1">
		<Icon {...props} />
	</a>
);

const featureList = [
	{
		item: (
			<>
				Family Owned
				<span className="hidden md:inline"> & Operated</span>
			</>
		),
		icon: Users2
	},
	{
		item: <>Licensed & Certified</>,
		icon: BadgeCheck
	},
	{
		item: <>Free Estimates</>,
		icon: ListOrdered
	}
];

function Navbar({ headerTransparent = false, shadow = true }) {
	const companyname = 'Bay Area Siding Company';
	const description = 'desc';
	const slogan = 'Premier Bay Area Siding & Window Experts';
	const subtagline = 'Residential Exterior Home Renovation Experts';
	const phonenumber = '(415) 619-5167';
	const mainnavigationstyle = 'inline';

	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [contactFormOpen, setContactFormOpen] = useState(false);

	useEffect(() => {
		if (mobileMenuOpen) {
			document.body.classList.add('menu-expanded');
		}

		return function cleanup() {
			document.body.classList.remove('menu-expanded');
		};
	}, [mobileMenuOpen]);

	const MenuItem = ({ item, source, headerTransparent }) => {
		let itemId = item.id;
		let title = item.name;
		let slug = item.url;

		if (item.submenu && item.submenu.length > 0) {
			return (
				<MenuItemDropdown
					item={item}
					label={title}
					type={1}
					source={source}
					headerTransparent={headerTransparent}
				/>
			);
		}
		return (
			<Link
				to={`${slug && slug.length < 2 ? '/' : slug}`}
				className={`${
					source && source == 'mobilemenu'
						? 'block py-4 px-8 border-b border-gray-300'
						: `p-3 border-transparent hover:bg-gray-100 rounded-lg ${
								headerTransparent
									? 'text-white hover:border-brand-300 hover:text-brand-200'
									: 'text-gray-700 hover:text-gray-900    '
						  }`
				}  font-semibold text-[15px] font-display text-base   transition-colors duration-150 ease-in button-active-bhvr`}
				activeClassName="!text-black hover:text-black"
			>
				{item.name}
			</Link>
		);
	};

	return (
		<StaticQuery
			query={graphql`
				query SiteTitleQueryInNav {
					site {
						siteMetadata {
							title
							description
							companyInfo {
								phone
								email
								addressLine1
								addressLine2
								city
								state
								zip
								license
							}
						}
					}
					allContentfulNavigation(
						filter: { name: { eq: "Main Navigation" } }
					) {
						edges {
							node {
								id
								name
								menuItems {
									id
									name
									title
									url
									openInNewWindow
									submenu {
										id
										name
										menuItems {
											id
											name
											title
											url
											openInNewWindow
										}
									}
								}
								campaign
							}
						}
					}
				}
			`}
			render={data => {
				const items =
					data.allContentfulNavigation.edges[0].node.menuItems;
				return (
					<>
						<div
							className={`${'bg-gray-50 text-gray-700'}  font-display  block relative z-20`}
						>
							<div className="flex justify-center md:justify-between items-center font-display mx-auto py-3 text-xs md:text-sm max-w-7xl  px-4 md:px-6">
								<span className="block text-center md:text-left font-medium">
								<span style={{ display: "flex", alignItems: "center" }}>
								<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="w-6 h-6 mr-2"
    viewBox="0 0 68 49"
  >
    <path
      fill="#fff"
      d="M2.272 12.409S3.332 21.558 4 24.999c.646 3.331.724 7.12.724 7.12l-.184 3.768-.261 3.98-.323 3.564-.41 3.716s15.827-8.117 22.052-7.28c6.23.838 4.86-.612 5.423 1.437a17.2 17.2 0 0 0 1.405 3.538l19.426-1.163 2.557 4.002 13.144-1.008s-2.792-4.08-3.586-19.098c-.428-8.065-.41-9.32-.462-11.824-.075-3.65-.035-4.983-.035-4.983s-6.941 1.332-9.231.946c-.664-.113-2.43-1.128-2.43-1.128l-.123-2.362-1.195-1.996-22.873 2.869z"
    ></path>
    <path
      fill="#EA4335"
      d="M54.334 45.996s2.474.526 6.256.126 6.016-1.597 6.016-1.597l.951 2.148S64.185 49 58.427 49c-5.76 0-6.57-.699-6.57-.699zM4.5 28.5l.224 3.62s15.295-5.127 22.803-5.544c2.892-.16 4.471.309 4.471.309l-.362-3.39c.005 0-4.791-2.626-27.136 5.005M4.545 35.887l-.266 3.98s16.647-5.62 23.662-5.768c5.152-.109 4.812.681 4.812.681l-.349-4.189c-.004 0-5.514-3.02-27.86 5.296M33.141 40.974c11.072-1.962 20.094-2.804 20.696-1.662l-.349-3.086s-1.684-1.515-20.648 1.54z"
    ></path>
    <path
      fill="#EA4335"
      d="M32.727 34.945c10.221-1.901 19.945-2.8 20.552-1.658l-.31-3.342s-.85-1.85-20.543 1.792zM32.103 29.02c9.759-2.266 19.775-3.286 20.621-2.396l-.204-3.03s-1.344-1.831-20.644 2.349zM31.64 22.991c13.485-3.177 19.724-3.164 20.714-2.57l-.179-3.129s-2.295-1.328-20.814 2.54zM30.676 17.066c6.915-1.515 19.658-3.759 21.338-2.687l-.131-2.856s-2.225-1.884-21.7 2.44zM30.249 10.768c7.198-2.001 20.67-3.499 21.455-2.257l-.1-2.752S51.01 3.02 29.755 7.443z"
    ></path>
    <path
      fill="#5576BA"
      d="M0 5.5S1.065 10.79 4 25c0 0 13.947-4.205 19.661-4.917 7.657-.955 7.735.134 7.735.134S30.14 6.127 28.687 2.208C27.757-.3 23.269-.869 15.39 1.535S4.184 5.74 0 5.5"
    ></path>
    <path
      fill="#EA4335"
      d="m51.813 10.585.14 3.121s5.959 1.012 11.517-.963V9.639s-5.008 2.08-11.657.946M52.118 16.55l.192 2.986s5.65.998 11.26-.781l-.061-3.004s-4.328 1.927-11.39.798M52.44 22.566l.206 2.93s5.758 1.115 11.185-.652l-.148-3.103c-.004 0-4.184 1.953-11.242.825M52.847 28.395l.24 2.93s5.44 1.016 11.12-.651l-.236-3.104c-.004 0-4.066 1.958-11.124.825M53.305 34.229l.266 2.93s5.396 1.054 11.277-.651l-.397-3.104s-4.083 1.953-11.146.825M53.946 40.12l.34 2.925s5.222.968 11.587-1.055l-.589-2.778s-3.682 1.723-11.338.907"
    ></path>
    <path
      fill="#901F1D"
      d="M51.852 48.301s2.962-1.194 2.823-2.504c-.38-3.599-3.198-1.446-3.198-1.446z"
    ></path>
    <path
      fill="#EA4335"
      d="M54.622 45.363s-.833-2.5-23.946 1.784c0 0-.34-2.31-.392-2.965 11.299-1.984 23.514-3.395 23.928-1.806z"
    ></path>
    <path
      fill="#901F1D"
      d="m29.756 40.215.92 6.927s2.814-2.166 2.662-3.945c-.153-1.78-3.582-2.982-3.582-2.982"
    ></path>
    <path
      fill="#EA4335"
      d="m3.956 43.431-.41 3.716s16.399-5.678 25.486-5.995c4.114-.143 4.306 2.049 4.306 2.049l-.42-4.836c-.004 0-3.96-3.654-28.962 5.066"
    ></path>
    <path
      fill="#fff"
      d="m4.344 7.326-.3.356a.16.16 0 0 0-.014.186l.253.39a.13.13 0 0 1 .022.053c.022.117-.1.23-.227.182l-.436-.173a.2.2 0 0 0-.1-.009.17.17 0 0 0-.083.052l-.301.356c-.088.104-.253.06-.284-.052-.004-.017-.009-.035-.004-.057l.043-.464a.16.16 0 0 0-.1-.16l-.436-.174c-.144-.057-.136-.282.017-.321l.454-.113c.07-.018.122-.057.126-.126l.035-.465c.005-.078.061-.125.122-.143a.155.155 0 0 1 .175.07l.249.395c.034.056.104.07.17.052l.453-.113c.153-.03.266.16.166.278M5.29 10.768l-.3.356a.16.16 0 0 0-.013.186l.253.39a.13.13 0 0 1 .021.053c.022.117-.1.23-.226.182l-.437-.173a.2.2 0 0 0-.1-.009.17.17 0 0 0-.083.052l-.3.356c-.088.104-.254.06-.284-.052-.005-.018-.01-.035-.005-.056l.044-.465a.16.16 0 0 0-.1-.16l-.437-.174c-.144-.057-.135-.282.018-.321l.453-.113c.07-.018.123-.057.127-.126l.035-.465c.004-.078.06-.125.122-.143a.154.154 0 0 1 .174.07l.25.395c.034.056.104.07.17.052l.453-.113c.148-.035.266.16.166.278M6.085 14.205l-.301.356a.16.16 0 0 0-.013.187l.253.39c.013.018.017.035.021.053.022.117-.1.23-.226.182l-.437-.174a.2.2 0 0 0-.1-.008.17.17 0 0 0-.083.052l-.301.356c-.087.104-.253.06-.284-.053-.004-.017-.008-.034-.004-.056l.044-.464a.16.16 0 0 0-.1-.161l-.437-.174c-.144-.056-.135-.282.018-.32l.453-.11c.07-.017.122-.056.127-.125l.035-.465c.004-.078.06-.126.122-.143a.154.154 0 0 1 .174.07l.249.394c.035.057.105.07.17.053l.454-.113c.153-.035.27.156.166.273M6.984 17.79l-.301.357a.16.16 0 0 0-.014.186l.254.391a.13.13 0 0 1 .021.052c.022.117-.1.23-.227.183l-.436-.174a.2.2 0 0 0-.1-.009c-.035.005-.061.026-.083.052l-.301.356c-.087.104-.253.061-.284-.052-.004-.017-.008-.035-.004-.056l.044-.465a.16.16 0 0 0-.1-.16l-.437-.174c-.144-.056-.135-.282.018-.321l.453-.113c.07-.017.122-.056.127-.126l.035-.464c.004-.079.06-.126.122-.144a.154.154 0 0 1 .174.07l.249.395c.035.056.105.07.17.052l.454-.113c.148-.035.266.16.166.278M7.878 21.376l-.301.356a.16.16 0 0 0-.013.187l.253.39c.013.018.017.035.022.053.021.117-.1.23-.227.182l-.437-.174a.2.2 0 0 0-.1-.008c-.035.004-.06.026-.083.052l-.3.356c-.088.104-.254.06-.284-.052q-.01-.026-.005-.057l.044-.464a.16.16 0 0 0-.1-.16l-.437-.174c-.144-.057-.135-.283.018-.322l.454-.113c.07-.017.122-.056.126-.126l.035-.464c.004-.078.061-.126.122-.143a.155.155 0 0 1 .175.07l.248.394c.035.057.105.07.17.052l.454-.112c.148-.035.266.16.166.277M9.618 18.963l-.3.356a.16.16 0 0 0-.014.187l.253.39a.13.13 0 0 1 .022.052c.022.117-.1.23-.227.183l-.436-.174a.2.2 0 0 0-.1-.009.17.17 0 0 0-.083.052l-.301.356c-.088.104-.253.061-.284-.052a.1.1 0 0 1-.004-.056l.043-.465a.16.16 0 0 0-.1-.16l-.436-.174c-.144-.056-.135-.282.017-.321l.454-.113c.07-.017.122-.056.127-.126l.034-.464c.005-.078.061-.126.123-.143a.154.154 0 0 1 .174.069l.249.395c.035.056.104.07.17.052l.454-.113c.148-.034.266.16.165.278M8.772 15.377l-.3.356a.16.16 0 0 0-.014.187l.253.39q.018.026.022.053c.022.117-.1.23-.227.182l-.436-.174a.2.2 0 0 0-.1-.008.17.17 0 0 0-.083.052l-.301.356c-.088.104-.253.06-.284-.052-.004-.018-.009-.035-.004-.057l.043-.464a.16.16 0 0 0-.1-.16l-.436-.174c-.144-.057-.136-.283.017-.322l.454-.112c.07-.018.122-.057.126-.126l.035-.465c.005-.078.061-.126.122-.143a.155.155 0 0 1 .175.07l.249.394c.034.057.104.07.17.053l.453-.113c.149-.035.266.16.166.277M8.061 11.71l-.301.356a.16.16 0 0 0-.013.186l.253.391c.013.017.017.035.022.052.022.117-.1.23-.227.182l-.436-.173a.2.2 0 0 0-.1-.009c-.036.005-.062.026-.084.052l-.3.356c-.088.104-.254.06-.284-.052a.1.1 0 0 1-.005-.056l.044-.465a.16.16 0 0 0-.1-.16l-.437-.174c-.144-.056-.135-.282.018-.321l.454-.113c.07-.018.122-.056.126-.126l.035-.464c.004-.079.061-.126.122-.144a.155.155 0 0 1 .175.07l.248.395c.035.056.105.07.17.052l.454-.113c.153-.035.266.156.166.278M7.167 8.268l-.301.355a.16.16 0 0 0-.013.187l.253.39a.13.13 0 0 1 .021.053c.022.117-.1.23-.226.182l-.437-.173a.2.2 0 0 0-.1-.01.17.17 0 0 0-.083.053l-.3.356c-.088.104-.254.06-.284-.052-.005-.018-.01-.035-.005-.057l.044-.464a.16.16 0 0 0-.1-.16l-.437-.174c-.144-.057-.135-.282.018-.322l.453-.112c.07-.018.122-.057.127-.126l.035-.465c.004-.078.06-.126.122-.143a.155.155 0 0 1 .174.07l.249.395c.035.056.105.069.17.052l.454-.113c.153-.035.266.16.166.278M9.213 5.737l-.314.343a.16.16 0 0 0-.022.186l.24.4a.3.3 0 0 1 .021.052.168.168 0 0 1-.23.173l-.428-.186a.173.173 0 0 0-.188.04l-.314.346c-.092.1-.253.052-.284-.065a.3.3 0 0 1-.004-.056l.057-.465a.15.15 0 0 0-.096-.16l-.428-.187c-.144-.061-.122-.287.03-.317l.459-.096c.07-.013.122-.052.13-.121l.049-.465a.16.16 0 0 1 .126-.138.16.16 0 0 1 .175.073l.235.404c.035.06.1.074.17.06l.459-.095c.152-.034.261.16.157.274M10.037 9.21l-.314.342a.16.16 0 0 0-.022.187l.24.4q.015.025.022.051a.168.168 0 0 1-.231.174l-.428-.187a.16.16 0 0 0-.1-.008.2.2 0 0 0-.087.047l-.315.348c-.091.1-.253.052-.283-.066-.004-.017-.004-.039-.004-.056l.056-.464a.15.15 0 0 0-.096-.161l-.427-.187c-.144-.06-.122-.286.03-.317l.458-.095c.07-.013.123-.052.131-.122l.048-.464a.16.16 0 0 1 .127-.139.16.16 0 0 1 .174.074l.236.404c.035.06.1.073.17.06l.458-.095c.153-.04.262.156.157.273M10.718 12.673l-.314.343a.16.16 0 0 0-.022.187l.24.4q.013.025.022.051a.168.168 0 0 1-.232.174l-.427-.187a.16.16 0 0 0-.1-.008.2.2 0 0 0-.088.047l-.314.348c-.091.1-.253.052-.283-.066-.005-.017-.005-.039-.005-.056l.057-.465a.15.15 0 0 0-.096-.16l-.428-.187c-.144-.06-.122-.286.031-.317l.458-.095c.07-.013.122-.052.13-.122l.049-.468a.16.16 0 0 1 .126-.14.16.16 0 0 1 .175.075l.235.403c.035.06.1.074.17.06l.459-.095c.152-.034.261.165.157.278M11.49 16.284l-.314.343a.16.16 0 0 0-.022.187l.24.4a.3.3 0 0 1 .022.051.168.168 0 0 1-.231.174l-.428-.187a.173.173 0 0 0-.188.04l-.314.347c-.091.1-.253.052-.283-.066q-.006-.027-.005-.056l.057-.464a.15.15 0 0 0-.096-.16l-.427-.188c-.144-.06-.122-.286.03-.316l.458-.096c.07-.013.122-.052.131-.121l.048-.465a.16.16 0 0 1 .127-.139.16.16 0 0 1 .174.074l.236.404c.035.06.1.073.17.06l.458-.095c.153-.035.262.16.157.273M12.262 19.9l-.314.343a.16.16 0 0 0-.022.187l.24.399a.3.3 0 0 1 .022.052.168.168 0 0 1-.231.174l-.428-.187a.173.173 0 0 0-.188.04l-.314.346c-.091.1-.253.052-.283-.065-.005-.017-.005-.039-.005-.056l.057-.465a.15.15 0 0 0-.096-.16l-.427-.187c-.144-.06-.123-.286.03-.317l.458-.1c.07-.013.122-.052.131-.121l.048-.465a.16.16 0 0 1 .127-.139.16.16 0 0 1 .174.074l.236.404c.035.06.1.074.17.06l.458-.095c.153-.035.262.16.157.278M13.597 4.678l-.318.338a.16.16 0 0 0-.022.187l.236.404a.1.1 0 0 1 .017.056c.017.117-.114.226-.236.17l-.423-.196a.2.2 0 0 0-.1-.013.15.15 0 0 0-.087.048l-.319.338c-.091.1-.253.048-.284-.07q-.005-.027-.004-.056l.066-.46a.16.16 0 0 0-.092-.165l-.423-.195c-.14-.065-.118-.286.035-.317l.462-.091c.07-.013.122-.052.131-.122l.057-.464a.16.16 0 0 1 .13-.139.155.155 0 0 1 .17.078l.228.408c.034.061.1.074.17.061l.462-.091c.144-.022.249.178.144.29M14.36 8.163l-.318.339a.16.16 0 0 0-.022.187l.236.403q.015.026.017.057c.018.117-.113.225-.235.169l-.423-.195a.2.2 0 0 0-.1-.013.15.15 0 0 0-.088.047l-.319.339c-.091.1-.253.048-.283-.07-.004-.017-.004-.039-.004-.056l.065-.46a.16.16 0 0 0-.092-.165l-.423-.195c-.14-.065-.117-.287.035-.317l.463-.091c.07-.013.122-.052.13-.122l.057-.464a.16.16 0 0 1 .131-.14.155.155 0 0 1 .17.079l.227.408c.035.06.1.074.17.06l.463-.09c.144-.022.248.178.144.29M14.98 11.64l-.319.339a.16.16 0 0 0-.021.186l.235.404c.009.017.018.035.018.056.017.118-.114.226-.236.17l-.423-.195a.2.2 0 0 0-.1-.014.15.15 0 0 0-.088.048l-.318.339c-.092.1-.253.047-.284-.07-.004-.017-.004-.039-.004-.056l.065-.46a.16.16 0 0 0-.091-.165l-.423-.195c-.14-.066-.118-.287.034-.317l.463-.092c.07-.013.122-.052.13-.121l.058-.464a.16.16 0 0 1 .13-.14.155.155 0 0 1 .17.079l.227.408c.035.06.1.074.17.06l.463-.09c.144-.022.249.177.144.29M15.687 15.265l-.319.338a.16.16 0 0 0-.021.187l.235.404a.1.1 0 0 1 .018.056c.017.117-.114.226-.236.17l-.423-.196a.2.2 0 0 0-.1-.013.15.15 0 0 0-.088.048l-.318.338c-.092.1-.253.048-.284-.07q-.005-.027-.004-.056l.065-.46a.16.16 0 0 0-.091-.165l-.424-.195c-.14-.065-.117-.286.035-.317l.463-.091c.07-.013.122-.052.13-.122l.057-.464a.16.16 0 0 1 .131-.139.155.155 0 0 1 .17.078l.227.408c.035.061.1.074.17.061l.463-.091c.148-.022.253.178.144.29M16.398 18.89l-.319.338a.16.16 0 0 0-.021.186l.235.404a.1.1 0 0 1 .018.057c.017.117-.114.225-.236.169l-.423-.195c-.03-.014-.066-.018-.1-.014a.15.15 0 0 0-.088.048l-.318.339c-.092.1-.253.048-.284-.07-.004-.017-.004-.039-.004-.056l.065-.46a.16.16 0 0 0-.091-.165l-.423-.195c-.14-.066-.118-.287.034-.317l.463-.091c.07-.013.122-.052.13-.122l.058-.464a.16.16 0 0 1 .13-.14.155.155 0 0 1 .17.079l.227.408c.035.06.1.074.17.06l.463-.09c.144-.022.249.177.144.29M14.042 17.543l-.31.352a.16.16 0 0 0-.017.187l.249.395a.3.3 0 0 1 .021.052c.022.117-.104.23-.23.178l-.433-.183a.16.16 0 0 0-.1-.008.2.2 0 0 0-.087.052l-.31.351c-.087.1-.253.057-.284-.06a.1.1 0 0 1-.004-.057l.052-.464a.16.16 0 0 0-.096-.16l-.431-.183c-.144-.061-.127-.287.021-.317l.458-.104c.07-.018.123-.057.131-.126l.044-.465a.162.162 0 0 1 .301-.07l.24.4c.035.061.1.07.17.057l.458-.105c.149-.034.262.161.157.278M13.266 13.945l-.31.351a.16.16 0 0 0-.018.187l.25.395a.3.3 0 0 1 .02.052c.023.117-.104.23-.23.178l-.432-.182a.16.16 0 0 0-.1-.009.2.2 0 0 0-.088.052l-.31.352c-.087.1-.253.056-.283-.06-.005-.018-.009-.04-.005-.057l.053-.465a.16.16 0 0 0-.096-.16l-.432-.183c-.144-.06-.127-.286.022-.317l.458-.104c.07-.017.122-.056.13-.125l.044-.465a.162.162 0 0 1 .301-.07l.24.4c.035.06.1.07.17.056l.458-.104c.149-.035.258.16.158.278M12.624 10.26l-.31.351a.16.16 0 0 0-.017.187l.249.395q.013.027.022.052c.021.117-.105.23-.232.178l-.432-.182a.16.16 0 0 0-.1-.009.2.2 0 0 0-.087.052l-.31.352c-.087.1-.253.056-.284-.06-.004-.018-.008-.04-.004-.057l.053-.465a.16.16 0 0 0-.097-.16l-.431-.183c-.144-.06-.127-.286.021-.317l.459-.104c.07-.017.122-.056.13-.126l.044-.464a.163.163 0 0 1 .301-.07l.24.4c.035.06.1.07.17.056l.458-.104c.149-.035.262.16.157.278M11.795 6.805l-.31.351a.16.16 0 0 0-.017.187l.249.395a.3.3 0 0 1 .022.052c.021.117-.105.23-.232.178l-.431-.182a.16.16 0 0 0-.1-.009.2.2 0 0 0-.088.052l-.31.352c-.087.1-.253.056-.283-.061-.005-.017-.01-.04-.005-.057l.053-.464a.16.16 0 0 0-.096-.16l-.432-.183c-.144-.06-.127-.286.022-.317l.458-.104c.07-.017.122-.056.13-.126l.044-.464a.162.162 0 0 1 .301-.07l.24.4c.035.06.1.07.17.056l.458-.104c.149-.035.258.16.157.278M18.226 16.719l-.314.347a.16.16 0 0 0-.018.187l.245.4q.013.025.021.051c.022.117-.109.226-.23.174l-.433-.187a.16.16 0 0 0-.1-.008.3.3 0 0 0-.087.047l-.314.348c-.092.1-.253.052-.284-.061-.004-.018-.004-.04-.004-.057l.056-.464a.15.15 0 0 0-.096-.16l-.427-.187c-.144-.061-.127-.287.026-.317l.458-.1c.07-.013.122-.052.131-.122l.048-.464a.15.15 0 0 1 .127-.139.16.16 0 0 1 .174.074l.236.404c.034.06.1.073.17.056l.458-.1c.152-.035.262.165.157.278M17.484 13.112l-.314.347a.16.16 0 0 0-.017.187l.244.4a.3.3 0 0 1 .022.051c.021.117-.11.226-.232.174l-.427-.187a.16.16 0 0 0-.1-.009.3.3 0 0 0-.088.048l-.314.347c-.091.1-.253.053-.283-.06-.005-.018-.005-.04-.005-.057l.057-.464a.15.15 0 0 0-.096-.16l-.427-.187c-.144-.061-.127-.287.026-.317l.458-.1c.07-.013.122-.052.13-.122l.049-.464a.15.15 0 0 1 .126-.139.16.16 0 0 1 .175.074l.235.403c.035.061.1.074.17.057l.458-.1c.149-.035.258.16.153.278M16.882 9.422l-.314.348a.16.16 0 0 0-.018.186l.245.4q.013.025.022.052c.021.117-.11.225-.232.173l-.427-.186a.16.16 0 0 0-.1-.009.2.2 0 0 0-.088.048l-.314.347c-.091.1-.253.052-.283-.06-.005-.018-.005-.04-.005-.057l.057-.465a.15.15 0 0 0-.096-.16l-.428-.187c-.143-.06-.126-.286.027-.317l.458-.1c.07-.013.122-.052.13-.121l.049-.465a.15.15 0 0 1 .126-.138.16.16 0 0 1 .175.073l.235.404c.035.06.1.074.17.056l.458-.1c.149-.034.258.161.153.278M16.093 5.959l-.315.347a.16.16 0 0 0-.017.186l.244.4a.3.3 0 0 1 .022.052c.022.117-.109.226-.231.173l-.428-.186a.16.16 0 0 0-.1-.009.3.3 0 0 0-.087.048l-.319.347c-.091.1-.253.052-.283-.06-.005-.018-.005-.04-.005-.057l.057-.465a.15.15 0 0 0-.096-.16l-.428-.187c-.143-.06-.126-.286.027-.317l.458-.1c.07-.012.122-.052.13-.121l.049-.464a.15.15 0 0 1 .126-.14.16.16 0 0 1 .175.074l.235.404c.035.06.1.074.17.057l.458-.1c.149-.035.258.16.158.278M17.981 3.627l-.322.339a.165.165 0 0 0-.027.187l.232.408a.1.1 0 0 1 .017.056.164.164 0 0 1-.236.165l-.423-.2q-.046-.02-.1-.013a.14.14 0 0 0-.087.048l-.323.339c-.092.095-.258.043-.284-.07-.004-.017-.004-.039-.004-.056l.07-.46a.16.16 0 0 0-.092-.165l-.423-.2c-.14-.065-.118-.29.04-.317l.462-.087c.07-.013.126-.052.135-.117l.061-.464a.15.15 0 0 1 .13-.135c.066-.009.136.013.171.083l.223.408c.034.06.1.073.165.065l.463-.087c.161-.04.261.16.152.273M18.714 7.117l-.322.339a.165.165 0 0 0-.027.186l.232.408a.1.1 0 0 1 .017.057.164.164 0 0 1-.236.165l-.423-.2q-.046-.02-.1-.013a.14.14 0 0 0-.087.048l-.323.338c-.092.096-.258.044-.284-.069-.004-.017-.004-.04-.004-.056l.07-.46a.16.16 0 0 0-.092-.166l-.423-.2c-.14-.064-.118-.29.04-.316l.462-.087c.07-.013.126-.052.135-.117l.06-.465a.15.15 0 0 1 .132-.134.15.15 0 0 1 .17.082l.222.408c.035.061.1.074.166.066l.463-.087c.157-.04.261.16.152.273M19.303 10.598l-.323.339a.165.165 0 0 0-.026.187l.231.408q.017.024.018.056a.164.164 0 0 1-.236.165l-.423-.2q-.046-.02-.1-.013a.15.15 0 0 0-.087.048l-.323.339c-.092.095-.258.043-.284-.07-.004-.017-.004-.039-.004-.056l.07-.46a.16.16 0 0 0-.092-.165l-.423-.2c-.14-.065-.118-.29.04-.317l.461-.087c.07-.013.127-.052.136-.117l.06-.464a.15.15 0 0 1 .132-.135.15.15 0 0 1 .17.083l.222.408c.035.06.1.073.166.065l.463-.087c.157-.04.257.16.152.273M19.975 14.231l-.323.339a.165.165 0 0 0-.026.187l.231.408c.009.017.018.034.018.056a.164.164 0 0 1-.236.165l-.423-.2q-.046-.02-.1-.013a.14.14 0 0 0-.088.048l-.322.339c-.092.095-.258.043-.284-.07-.004-.017-.004-.039-.004-.056l.07-.46a.16.16 0 0 0-.092-.165l-.423-.2c-.14-.065-.118-.29.039-.317l.462-.087c.07-.013.127-.052.136-.117l.065-.473a.15.15 0 0 1 .13-.135c.066-.008.136.013.171.083l.223.408c.034.06.1.074.165.065l.463-.087c.152-.03.257.17.148.282M20.651 17.86l-.323.339a.165.165 0 0 0-.026.186l.232.408a.1.1 0 0 1 .017.057.164.164 0 0 1-.236.165l-.423-.2q-.046-.02-.1-.013a.15.15 0 0 0-.087.048l-.323.338c-.092.096-.258.044-.284-.07-.004-.016-.004-.038-.004-.055l.07-.46a.16.16 0 0 0-.092-.166l-.423-.2c-.14-.064-.118-.29.04-.316l.462-.087c.07-.013.126-.052.135-.117l.06-.465a.15.15 0 0 1 .132-.134.15.15 0 0 1 .17.082l.222.408c.035.061.1.074.166.066l.463-.087c.157-.035.261.165.152.273M22.457 15.725l-.318.343a.16.16 0 0 0-.022.186l.235.404a.1.1 0 0 1 .018.056c.017.118-.114.226-.236.17l-.427-.196a.2.2 0 0 0-.1-.013.16.16 0 0 0-.088.048l-.318.343c-.092.1-.253.048-.284-.065-.004-.018-.004-.04-.004-.057l.06-.46a.16.16 0 0 0-.09-.165l-.428-.195c-.14-.065-.122-.286.035-.317l.458-.091c.07-.013.122-.052.13-.121l.057-.465a.16.16 0 0 1 .127-.139.15.15 0 0 1 .17.078l.231.408c.035.061.1.074.17.061l.458-.091c.17-.035.275.165.166.278M21.781 12.105l-.318.342a.16.16 0 0 0-.022.187l.235.404a.1.1 0 0 1 .018.056c.017.117-.113.226-.236.17l-.427-.196q-.047-.02-.1-.013a.16.16 0 0 0-.088.048l-.318.343c-.092.1-.253.047-.284-.065-.004-.018-.004-.04-.004-.057l.06-.46a.16.16 0 0 0-.09-.165l-.428-.195c-.14-.065-.122-.287.035-.317l.466-.095c.07-.014.123-.053.131-.122l.057-.465a.16.16 0 0 1 .127-.138c.065-.013.135.008.17.078l.23.408c.036.06.101.074.171.06l.458-.09c.157-.031.262.169.157.281M21.245 8.406l-.319.343a.16.16 0 0 0-.022.187l.236.404a.1.1 0 0 1 .017.056c.018.117-.113.226-.235.17l-.428-.196q-.046-.02-.1-.013a.16.16 0 0 0-.087.048l-.319.343c-.091.1-.253.047-.284-.066-.004-.017-.004-.039-.004-.056l.061-.46A.16.16 0 0 0 19.67 9l-.428-.195c-.14-.065-.122-.287.035-.317l.458-.091c.07-.013.122-.052.131-.122l.057-.464a.16.16 0 0 1 .126-.14c.066-.012.135.01.17.079l.232.408c.034.06.1.074.17.06l.458-.09c.165-.035.27.164.165.277M20.512 4.925l-.319.343a.16.16 0 0 0-.022.187l.236.403q.015.025.017.057c.018.117-.113.226-.235.17l-.428-.196q-.046-.02-.1-.013a.16.16 0 0 0-.087.047l-.319.343c-.091.1-.253.048-.283-.065-.005-.017-.005-.039-.005-.056l.061-.46a.16.16 0 0 0-.091-.165l-.428-.196c-.14-.065-.122-.286.035-.316l.458-.092c.07-.013.122-.052.131-.121l.057-.465a.16.16 0 0 1 .126-.138c.066-.013.136.008.17.078l.232.408c.035.06.1.074.17.06l.458-.09c.166-.031.27.164.166.277M22.706 3.055l-.331.33a.16.16 0 0 0-.03.186l.222.412a.2.2 0 0 1 .017.057c.013.117-.122.221-.24.16l-.419-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.332.33c-.096.096-.257.04-.28-.078a.1.1 0 0 1 0-.056l.08-.46a.16.16 0 0 0-.088-.165l-.419-.209c-.14-.069-.109-.29.044-.316l.463-.074c.07-.013.126-.048.135-.117l.074-.46a.16.16 0 0 1 .135-.135.16.16 0 0 1 .17.082l.214.417c.03.06.096.078.166.065l.462-.074c.157-.03.258.174.144.283M23.36 6.562l-.331.33a.16.16 0 0 0-.03.186l.222.413a.2.2 0 0 1 .017.056c.013.117-.122.222-.24.16L22.58 7.5a.13.13 0 0 0-.1-.013.2.2 0 0 0-.088.044l-.331.33c-.096.095-.258.039-.28-.078a.1.1 0 0 1 0-.057l.079-.46a.16.16 0 0 0-.087-.165l-.415-.217c-.14-.07-.109-.29.044-.317l.462-.074c.07-.013.127-.047.135-.117l.075-.46a.164.164 0 0 1 .305-.052l.214.417c.03.06.096.078.166.065l.462-.074c.153-.022.249.178.14.29M23.871 10.056l-.332.33a.16.16 0 0 0-.03.187l.222.412a.2.2 0 0 1 .018.056c.013.118-.122.222-.24.161l-.419-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.332.33c-.096.096-.258.04-.28-.078a.1.1 0 0 1 0-.056l.08-.46a.16.16 0 0 0-.088-.165l-.419-.209c-.14-.07-.109-.29.044-.317l.462-.074c.07-.013.127-.047.136-.117l.074-.46a.16.16 0 0 1 .135-.134.16.16 0 0 1 .17.082l.214.417c.03.06.096.078.166.065l.462-.074c.153-.03.253.17.144.282M24.46 13.702l-.332.33a.16.16 0 0 0-.03.187l.222.412c.009.018.013.04.018.056.013.118-.123.222-.24.161l-.42-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.331.33c-.096.096-.258.04-.28-.078a.1.1 0 0 1 0-.056l.08-.46a.16.16 0 0 0-.088-.165l-.419-.209c-.14-.07-.109-.29.044-.317l.462-.073c.07-.014.127-.048.135-.118l.075-.46a.164.164 0 0 1 .305-.052l.214.417c.03.06.096.078.165.065l.463-.074c.157-.03.257.17.144.282M25.053 17.348l-.331.33a.16.16 0 0 0-.03.187l.222.412a.2.2 0 0 1 .017.056c.013.118-.122.222-.24.161l-.418-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.088.043l-.332.33c-.096.096-.257.04-.279-.078a.1.1 0 0 1 0-.056l.079-.46a.16.16 0 0 0-.088-.165l-.418-.209c-.14-.07-.11-.29.043-.317l.463-.073c.07-.014.126-.048.135-.118l.074-.46a.164.164 0 0 1 .305-.052l.214.417c.03.06.096.078.166.065l.462-.074c.157-.03.253.17.144.282M27.444 2.79l-.332.33a.16.16 0 0 0-.03.186l.222.413a.2.2 0 0 1 .018.056c.013.117-.123.221-.24.16l-.42-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.044l-.331.33c-.096.095-.258.039-.28-.079a.1.1 0 0 1 0-.056l.079-.46a.16.16 0 0 0-.087-.165l-.419-.208c-.14-.07-.11-.291.044-.317l.462-.074c.07-.013.127-.048.135-.117l.074-.46a.16.16 0 0 1 .136-.135.16.16 0 0 1 .17.082l.214.417c.03.06.095.078.165.065l.463-.074c.157-.03.253.174.144.283M28.098 6.297l-.331.33a.16.16 0 0 0-.031.187l.222.412a.2.2 0 0 1 .018.056c.013.117-.122.222-.24.16l-.419-.207a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.332.33c-.096.095-.257.039-.28-.078a.1.1 0 0 1 0-.057l.08-.46a.16.16 0 0 0-.088-.165l-.419-.217c-.14-.07-.109-.29.044-.317l.462-.073c.07-.013.127-.048.136-.118l.074-.46a.164.164 0 0 1 .305-.052l.214.417c.03.06.096.078.166.065l.462-.074c.153-.022.253.178.144.291M28.604 9.791l-.331.33a.16.16 0 0 0-.031.187l.223.412a.2.2 0 0 1 .017.056c.013.118-.122.222-.24.161l-.419-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.332.33c-.096.096-.257.04-.28-.078a.1.1 0 0 1 0-.056l.08-.46a.16.16 0 0 0-.088-.165l-.419-.209c-.14-.07-.109-.29.044-.317l.462-.074c.07-.013.127-.047.136-.117l.074-.46a.16.16 0 0 1 .135-.134.16.16 0 0 1 .17.082l.214.417c.03.06.096.078.166.065l.462-.074c.157-.03.253.174.144.282M29.197 13.437l-.331.33a.16.16 0 0 0-.03.187l.222.412c.009.017.013.04.017.056.013.118-.122.222-.24.161l-.419-.208a.13.13 0 0 0-.1-.013.15.15 0 0 0-.087.043l-.332.33c-.096.095-.257.039-.279-.078a.1.1 0 0 1 0-.057l.079-.46a.16.16 0 0 0-.088-.165l-.418-.208c-.14-.07-.11-.29.043-.317l.463-.074c.07-.013.126-.047.135-.117l.074-.46a.164.164 0 0 1 .305-.052l.214.417c.03.06.096.078.166.065l.462-.074c.157-.03.253.17.144.282M29.79 17.083l-.33.33a.16.16 0 0 0-.031.187l.222.412a.2.2 0 0 1 .018.057c.013.117-.123.221-.24.16l-.42-.208a.13.13 0 0 0-.1-.013.2.2 0 0 0-.087.043l-.331.33c-.096.096-.258.04-.28-.078a.1.1 0 0 1 0-.056l.079-.46a.16.16 0 0 0-.087-.165l-.42-.209c-.139-.07-.108-.29.044-.317l.463-.073c.07-.014.127-.048.135-.118l.074-.46a.164.164 0 0 1 .305-.052l.214.417c.031.06.096.078.166.065l.463-.074c.152-.03.253.17.144.282M27.204 15.343l-.327.334a.16.16 0 0 0-.026.187l.226.408q.017.024.018.056c.013.117-.118.221-.24.165l-.419-.204a.13.13 0 0 0-.1-.013.14.14 0 0 0-.087.048l-.328.334c-.096.095-.257.043-.279-.074a.1.1 0 0 1 0-.056l.074-.46a.16.16 0 0 0-.087-.165l-.419-.204c-.14-.07-.113-.291.04-.317l.462-.078c.07-.013.126-.048.135-.118l.066-.46a.16.16 0 0 1 .13-.134.15.15 0 0 1 .17.082l.219.413c.03.06.096.078.166.065l.462-.079c.153-.039.253.161.144.27M26.624 11.71l-.327.334a.16.16 0 0 0-.027.186l.227.408a.1.1 0 0 1 .018.057c.013.117-.118.221-.24.165l-.419-.204a.13.13 0 0 0-.1-.013.14.14 0 0 0-.088.047l-.327.335c-.096.095-.257.043-.279-.074a.1.1 0 0 1 0-.056l.074-.46a.16.16 0 0 0-.087-.166l-.419-.204c-.14-.069-.113-.29.04-.316l.462-.079c.07-.013.126-.047.135-.117l.066-.46a.16.16 0 0 1 .13-.134.15.15 0 0 1 .17.082l.219.412c.03.061.096.079.165.066l.463-.079c.153-.043.253.157.144.27M26.183 7.998l-.327.335a.16.16 0 0 0-.026.186l.226.408q.017.025.018.057c.013.117-.118.221-.24.165l-.419-.204a.13.13 0 0 0-.1-.013.14.14 0 0 0-.088.047l-.327.335c-.096.095-.257.043-.279-.074a.1.1 0 0 1 0-.057l.074-.46a.16.16 0 0 0-.087-.165l-.419-.204c-.14-.07-.113-.29.04-.317l.462-.078c.07-.013.126-.047.135-.117l.066-.46a.16.16 0 0 1 .13-.135.15.15 0 0 1 .17.083l.219.412c.03.061.096.078.165.065l.463-.078c.153-.043.253.157.144.27M25.542 4.5l-.327.334a.16.16 0 0 0-.027.187l.227.408c.009.017.018.034.018.056.013.117-.118.221-.24.165l-.419-.204a.13.13 0 0 0-.1-.013.14.14 0 0 0-.088.048l-.327.334c-.096.095-.257.043-.279-.074a.1.1 0 0 1 0-.056l.074-.46a.16.16 0 0 0-.087-.165l-.419-.204c-.14-.07-.113-.291.04-.317l.462-.078c.07-.013.126-.048.135-.117l.066-.46a.16.16 0 0 1 .13-.135.15.15 0 0 1 .17.082l.219.413c.03.06.096.078.165.065l.463-.078c.152-.044.253.16.144.269"
    ></path>
  </svg> 
  Full-Service Siding & Window Experts in Bay
  Area </span> 
								</span>
								<span className="hidden md:flex flex-row gap-2 items-center">
								<span style={{ fontWeight: 400, fontStyle: "italic", display: "flex", alignItems: "center" }}>
								 Residential&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/bay-area-multifamily-exterior-siding-windows-renovation/">Multi-Family</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/bay-area-expert-siding-window-solutions-apartment-complexes/">Commercial</a>&nbsp;&nbsp;
</span>
<IconLink
										href="#"
										icon={Instagram}
										width="20"
										height="20"
									/>
									<IconLink
										href="https://www.yelp.com/biz/bay-area-siding-company-larkspur"
										icon={Yelp}
										width="20"
										height="20"
									/>
									<IconLink
										href="#"
										icon={Google}
										width="24"
										height="24"
									/>
									<IconLink
										href="#"
										icon={FacebookIcon}
										width="24"
										height="24"
									/>
								</span>
							</div>
						</div>
						<div
							className={`sticky top-0 z-[20]  ${
								headerTransparent
									? 'header--transparent-main'
									: ''
							}`}
						>
							<div
								className={`${
									headerTransparent
										? ' md:bg-transparent bg-transparent md:-mb-[90px]  '
										: 'bg-white'
								} ${
									!shadow ? '' : 'md:shadow-sm nav-shadow'
								} relative z-20 `}
							>
								<div className="flex justify-between items-center px-4 md:px-6 py-4 lg:py-0 md:space-x-10 max-w-7xl mx-auto md:h-[90px]">
									<div className="flex items-center">
										{' '}
										<div
											className={`mr-2 pr-2 border-r -my-2 md:hidden sm:pr-0 sm:m-0`}
										>
											<button
												type="button"
												onClick={() =>
													setMobileMenuOpen(
														!mobileMenuOpen
													)
												}
												className={`${
													headerTransparent
														? 'text-white'
														: ' text-gray-600 hover:bg-gray-200  focus:text-gray-700  focus:bg-gray-50'
												} text-center p-2 rounded-lg  focus:outline-none  transition duration-150 ease-in`}
											>
												{mobileMenuOpen ? (
													<svg
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
														viewBox="0 0 24 24"
														stroke-width="1.5"
														stroke="currentColor"
														className="h-6 w-6 mx-auto"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															d="M6 18L18 6M6 6l12 12"
														/>
													</svg>
												) : (
													<svg
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
														viewBox="0 0 24 24"
														stroke-width="1.5"
														stroke="currentColor"
														className="h-6 w-6 mx-auto"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															d="M3.75 9h16.5m-16.5 6.75h16.5"
														/>
													</svg>
												)}

												<span
													className="block uppercase font-normal tracking-wide"
													style={{
														fontSize: '.5rem'
													}}
												>
													Menu
												</span>
											</button>
										</div>
										<Link
											to="/"
											className="group p-1 shrink-0 flex items-center "
											title={companyname}
										>
											<div className="block xxs:w-36 w-[10rem] sm:w-[11rem] md:w-[13rem] lg:w-[13rem]">
												<Logo
													classes={
														headerTransparent
															? 'text-white'
															: 'text-brand-500'
													}
												/>
											</div>
										</Link>
									</div>

									{mainnavigationstyle == 'inline' ? (
										<div className="items-center font-display md:space-x-4 hidden lg:flex">
											{items.map((item, i) => {
												return (
													<MenuItem
														key={item.id}
														item={item}
														type={item.type}
														headerTransparent={
															headerTransparent
														}
													/>
												);
											})}
										</div>
									) : null}

									<div className="flex-1" />

									{mainnavigationstyle == 'stacked' ? (
										<div className="hidden lg:block font-display text-center">
											<span className="font-semibold block">
												{slogan}
											</span>
											<span className="font-normal text-sm text-gray-800 block">
												{subtagline}
											</span>
										</div>
									) : null}

									<div className="  font-display shrink-0">
										<div className="flex flex-col sm:flex-row items-center">
											<div className=" sm:pr-8 text-center">
												<a
													className={`mb-1 block font-bold text-base sm:text-xl lg:text-xl  tracking-tight ${
														headerTransparent
															? 'text-white'
															: 'text-gray-900'
													}`}
													href={`tel:${phonenumber}`}
												>
													{phonenumber}
												</a>
											</div>
											<div>
												<Button
													onClick={() =>
														setContactFormOpen(true)
													}
													className="px-3 py-2   sm:px-4 sm:py-2 lg:py-3 lg:px-5   button-active-bhvr whitespace-no-wrap flex items-center block cursor-pointer transition duration-150 ease-in-out bg-brand-600 focus:bg-brand-700 hover:bg-brand-700 focus:outline-none font-semibold  text-white font-display"
												>
													<span className="text-[13px] sm:text-sm font-medium">
														Free Estimate
													</span>{' '}
													<ArrowRight className="h-3 w-3 sm:w-4 sm:h-4 ml-1" />
												</Button>
												<ContactFormModal
													modalOpen={contactFormOpen}
													onModalClose={
														setContactFormOpen
													}
												/>
											</div>
										</div>
									</div>
								</div>

								{/* <Transition
                  show={mobileMenuOpen}
                  enter="duration-200 ease-out"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="duration-100 ease-in"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                  className={`absolute inset-x-0 transition transform origin-top-right z-50 ${mainnavigationstyle == 'stacked' ? 'md:hidden' : 'lg:hidden'}`}
                  style={{ top: '100%' }}
                >
                  <div className=" shadow-lg font-display">
                    <div className="shadow-xs bg-white">

                      <div>
                        {items.map((item, i) => {
                          return <MenuItem key={i} item={item} type={item.type} source={'mobilemenu'} />;
                        })}
                      </div>
                    </div>
                  </div>
                </Transition> */}
							</div>

							{mainnavigationstyle == 'stacked' ? (
								<div className="relative bg-white text-white md:shadow-sm md:border-none z-10 hidden md:block font-display">
									<div className="flex items-center px-4 md:px-6 md:space-x-10 container mx-auto ">
										{items.map((item, i) => {
											return (
												<MenuItem
													key={i}
													item={item}
													type={item.type}
												/>
											);
										})}
									</div>
								</div>
							) : null}
						</div>
						{/* <div className={`sticky top-0  z-20 md:hidden py-1 px-2 ${headerTransparent ? "-mb-48" : "bg-brand-600"}`}>
              <div
                className={` shadow-sm md:border-none ${
                  headerTransparent
                    ? "shadow-lg bg-brand-600/90 backdrop-blur-lg rounded-2xl text-brand-900 "
                    : "bg-brand-600  text-brand-900 "
                }`}
              >
                <div className="flex  items-center justify-between px-4 md:px-6  py-3 container mx-auto ">
                  <div>
                    <p className="mb-0 text-white font-display hidden sm:block">Give Us A Call Today</p>
                    <a className={`block font-semibold text-xl font-display text-white`} href={`tel:${phonenumber}`}>
                      {phonenumber}
                    </a>
                  </div>
                  <Button onClick={() => setContactFormOpen(true)} className="bg-brand-800 py-2.5 px-4 -my-1">
                    Free Estimate
                  </Button>
                </div>
              </div>
            </div> */}

						<Transition.Root show={mobileMenuOpen} as={Fragment}>
							<Dialog
								as="div"
								className="relative z-20"
								onClose={setMobileMenuOpen}
							>
								<Transition.Child
									as={Fragment}
									enter="ease-in-out duration-500"
									enterFrom="opacity-0"
									enterTo="opacity-100"
									leave="ease-in-out duration-500"
									leaveFrom="opacity-100"
									leaveTo="opacity-0"
								>
									<div className="fixed inset-0 bg-black  bg-opacity-75 transition-opacity" />
								</Transition.Child>

								<div className="fixed inset-0 overflow-hidden">
									<div className="absolute inset-0 overflow-hidden">
										<div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
											<Transition.Child
												as={Fragment}
												enter="transform transition ease-in-out duration-500 sm:duration-700"
												enterFrom="-translate-x-full "
												enterTo="translate-x-0"
												leave="transform transition ease-in-out duration-500 sm:duration-700"
												leaveFrom="translate-x-0"
												leaveTo="-translate-x-full"
											>
												<Dialog.Panel className="pointer-events-auto w-screen max-w-md">
													<div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
														<div className="px-4 sm:px-6">
															<div className="flex items-start justify-between">
																<Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
																	<Link
																		to="/"
																		className="block w-36 md:w-40  p-2 shrink-0"
																		title={
																			companyname
																		}
																	>
																		<Logo
																			classes={
																				headerTransparent
																					? 'text-brand-500'
																					: 'text-brand-500'
																			}
																		/>
																	</Link>
																</Dialog.Title>
																<div className="ml-3 flex h-8 items-center">
																	<button
																		type="button"
																		className="rounded-lg text-brand-700 hover:text-gray-500 focus:outline-none  "
																		onClick={() =>
																			setMobileMenuOpen(
																				false
																			)
																		}
																	>
																		<span className="sr-only">
																			Close
																			panel
																		</span>
																		<X
																			className="h-6 w-6"
																			aria-hidden="true"
																		/>
																	</button>
																</div>
															</div>
														</div>
														<div className="relative mt-6 font-display">
															{' '}
															<div>
																{items.map(
																	(
																		item,
																		i
																	) => {
																		return (
																			<MenuItem
																				key={
																					i
																				}
																				item={
																					item
																				}
																				type={
																					item.type
																				}
																				source={
																					'mobilemenu'
																				}
																			/>
																		);
																	}
																)}
															</div>
														</div>
														<div className="p-6">
															<div>
																<a
																	className={`mb-3 block font-bold  text-xl  lg:text-2xl `}
																	href={`tel:${phonenumber}`}
																>
																	{
																		phonenumber
																	}
																</a>
															</div>

															<Button to="/contact">
																Get a FREE
																Estimate{' '}
																<ArrowRight
																	size={18}
																/>
															</Button>
														</div>
													</div>
												</Dialog.Panel>
											</Transition.Child>
										</div>
									</div>
								</div>
							</Dialog>
						</Transition.Root>

						<div className="bg-gradient-to-r from-green-600 to-green-500 text-gray-800">
							{featureList && (
								<div className="mx-auto flex  items-center justify-center gap-3 py-3 md:gap-5">
									{featureList.map((item, i) => {
										return (
											<>
												{' '}
												{i > 0 && (
													<span className="text-white">
														/
													</span>
												)}
												<div
													className="flex flex-row items-center"
													key={i}
												>
													{i === 0 ? (
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="16"
															height="16"
															viewBox="0 0 24 24"
															fill="none"
															stroke="currentColor"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
															className="white-600 mr-2 hidden shrink-0 text-white sm:block"
														>
															<path d="M14 19a6 6 0 0 0-12 0"></path>
															<circle
																cx="8"
																cy="9"
																r="4"
															></circle>
															<path d="M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8"></path>
														</svg>
													) : (
														item.icon && (
															<item.icon
																className="white-600 mr-2 hidden shrink-0 text-white sm:block"
																size={16}
															/>
														)
													)}

													<p className="text-left text-xs sm:text-sm font-medium leading-6 text-white">
														{item.item}
													</p>
												</div>
											</>
										);
									})}
								</div>
							)}
						</div>
					</>
				);
			}}
		/>
	);
}

export default Navbar;
